module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-type"
  }, [_c('div', {
    staticClass: "box-wrap"
  }, [_vm._m(0), _vm._l((_vm.getTicketTypes.data), function(ticket, index) {
    return (ticket.active === 1 && ticket.count > 1) ? _c('div', {
      staticClass: "box select-box group",
      class: {
        selected: _vm.typeSelected.index === index, soldOutStatus: ticket.is_sold_out === true
      },
      attrs: {
        "disabled": _vm.dateNow < ticket.register_start_at
      },
      on: {
        "click": function($event) {
          _vm.typeSelect(ticket.min_group_limit, ticket.max_group_limit, index, ticket.id, _vm.dateNow < ticket.register_start_at, ticket.is_sold_out === true, ticket.description)
        }
      }
    }, [(_vm.typeSelected.index === index) ? _c('div', {
      staticClass: "img",
      style: ({
        backgroundImage: 'url(' + ticket.banner_urls.hover + ')'
      })
    }) : _c('div', {
      staticClass: "img",
      style: ({
        backgroundImage: 'url(' + ticket.banner_urls.general + ')'
      })
    }), (ticket.is_sold_out === true) ? _c('div', {
      staticClass: "soldout"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("SOLD OUT")])]) : _vm._e(), _c('h3', [_vm._v(_vm._s(ticket.title))]), _c('ul', {
      staticClass: "info"
    }, [(ticket.min_group_limit !== ticket.max_group_limit) ? _c('li', [_vm._v(_vm._s(ticket.min_group_limit) + " ~ " + _vm._s(ticket.max_group_limit) + " 席(含)")]) : _vm._e(), (ticket.min_group_limit === ticket.max_group_limit) ? _c('li', [_vm._v(_vm._s(ticket.min_group_limit) + " 席")]) : _vm._e(), _c('li', [_c('span', [_vm._v(_vm._s(_vm._f("moment")(ticket.register_start_at)) + " ")]), _c('small', [_vm._v("(" + _vm._s(_vm._f("moment")(ticket.register_start_at, 'Ahh:mm')) + ") ")]), _c('span', [_vm._v("- " + _vm._s(_vm._f("moment")(ticket.register_end_at)))])]), _c('li', [_c('span', [_vm._v(_vm._s(_vm.seatEnd(ticket.seat_end_at)))])]), _c('li', [_vm._v("＄" + _vm._s(ticket.price) + "/席")])])]) : _vm._e()
  }), _c('div', {
    staticClass: "box select-box group soldOutStatus"
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + _vm.bodily + ')'
    })
  }), _vm._m(1), _c('h3', [_vm._v("身障票")]), _vm._m(2)])], 2), _c('hr'), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('router-link', {
    staticClass: "btn ghost-btn next-btn",
    attrs: {
      "to": {
        name: 'ticketInfo'
      },
      "disabled": _vm.typeSelected === 0
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box header-title"
  }, [_c('ul', {
    staticClass: "info"
  }, [_c('li', [_vm._v("購票限制")]), _c('li', [_vm._v("開賣-截止")]), _c('li', [_vm._v("劃位截止")]), _c('li', [_vm._v("票價")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "soldout"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("SOLD OUT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "info"
  }, [_c('li', [_vm._v("1 ~ 2 席(含)")]), _c('li', [_c('span', [_vm._v("9/4 ")]), _c('small', [_vm._v("(中午12:00) ")]), _c('span', [_vm._v("- 11/10")])]), _c('li', [_c('span', [_vm._v("11/10 中午 12:00")])]), _c('li', [_vm._v("$1000/2席")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db1756ac"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tickets/ticketType.vue
// module id = 583
// module chunks = 1